import { QuestionList, Summary, ModuleList } from './../../../../models';
import { SeriesService } from './../../../../services/series.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import * as jquery from 'jquery';
import { PlyrComponent } from 'ngx-plyr';
import * as Plyr from 'plyr';

declare var require: any;

@Component({
  selector: 'series-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class SeriesEditComponent implements OnInit {

  @ViewChild('imageFileInput') imageFileInput;
  @ViewChild('videoFileInput') videoFileInput;
  @ViewChild(PlyrComponent, { static: true }) plyr: PlyrComponent;

  series: any;
  modules: ModuleList[];
  moduleId: number;
  moduleLength = 0;
  moduleDetails: any;
  seriesId: number;
  sequenceNo: number;
  isPublished: boolean;
  preloaderImage = require('../../../../../assets/images/loader-big.svg');
  questions: QuestionList[] = [];
  summaries: Summary[] = [];
  loading = false;
  incorrectAnswers: any[] = [];
  showAddModuleButton = true;
  coverColor: string;
  imageSourcePreview = '';
  imageUploadLabel = 'Upload';
  imageUploadFile: any;
  imageError = false;
  videoUploadLabel = 'Upload';
  videoUploadFile: any;
  videoError = false;
  videoErrorMsg = 'Video Cover is required!';
  addNewModule = false;
  moduleForm: FormGroup;
  submitted = false;
  submitSuccess = false;
  submitError = false;
  modalMessage = 'New Module was successfully created.';
  changeSeriesStatusError = false;
  seriesStatusText = 'Draft';
  modalText = 'Loading...';
  error = false;

  // Video Player
  videoPlayer: Plyr;
  videoSourcePreview: Plyr.Source[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private seriesService: SeriesService
  ) { }

  ngOnInit(): void {
    this.getRouteStates();
    this.getRouteParams();
    this.loadData();
    this.setFormControls();

    // Enables to reload current route
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    // Sets the height of container to window size
    jquery('#module-details-container').height(jquery(window).height() - 200);

    // Hides tinyMCE toolbar on scroll
    jquery('#module-details-container').scroll(() => {
      jquery('.tox-tinymce').css({display: 'none'});
      jquery('.mce-content-body').blur();
    });

  }

  private getRouteStates(): void {
    // Get the submit success state for newly created module
    if (window.history.state && window.history.state.hasOwnProperty('newModuleSuccess')) {
      this.submitSuccess = window.history.state.newModuleSuccess;
    }

    // Get the modal message
    if (window.history.state && window.history.state.hasOwnProperty('modalMessage')) {
      this.modalMessage = window.history.state.modalMessage;
    }
  }

  private setFormControls(): void {
    this.moduleForm = new FormGroup({
      moduleName: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(35)
      ]),
      moduleDescription: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(100),
      ]),
    });
  }

  private getRouteParams(): void {
    this.seriesId = this.route.snapshot.params.seriesId;
    this.sequenceNo = this.route.snapshot.params.sequenceNo;
  }

  loadData() {

    this.getRouteParams();

    if (!this.submitSuccess) {
      // Show progress modal
      this.showProgressModal();
    }

    this.seriesService.getSeriesModulesAdmin(this.seriesId)
      .subscribe(
        seriesData => {
          if (seriesData.success) {
            this.series = seriesData.data.series;
            this.series.status = this.capitalizeFirstCharacter(this.series.status);

            if (this.series.status === 'Published') {
              this.isPublished = true;
              this.seriesStatusText = 'Published';
            } else {
              this.isPublished = false;
              this.seriesStatusText = 'Draft';
            }

            this.modules = seriesData.data.modules;
            this.moduleLength = this.modules?.length;
            this.modules.sort(this.sortByValues);
            if (this.sequenceNo > 0 ) {
              this.moduleDetails = this.modules.find(data => data.details.sequence_number == this.sequenceNo);

              if (this.moduleDetails.quiz.questions?.length > 0) {
                this.questions = this.moduleDetails.quiz.questions;
              } else {
                this.questions = [];
              }

              this.summaries = this.moduleDetails.summary;
              this.coverColor = '#' + this.moduleDetails.details?.cover_color;
              this.moduleId = this.moduleDetails.details.id;

              // Sets form values
              this.f.moduleName.setValue(this.moduleDetails.details?.name);
              this.f.moduleDescription.setValue(this.moduleDetails.details?.description);

              // Get the index of the first incorrect answers per question
              if (this.questions?.length > 0) {
                this.incorrectAnswers = this.questions.map(data => {
                  return data.answers.findIndex(x => x.correct == 0);
                });
              }
            }

            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);

          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  addAnswer(questionId: number) {
    this.questions[questionId].answers.push(
      {
        id: 0,
        answer: '',
        correct: 0,
        sequence: 0
      }
    );
  }

  addSummary() {
    this.summaries.push({
      id: 0,
      sequence: this.summaries.length + 1,
      text: ''
    });
  }

  addQuestion() {
    this.questions.push({
      id: 0,
      question: '',
      answers: [{
          id: 0,
          answer: '',
          correct: 1,
          sequence: 0
        },
        {
          id: 0,
          answer: '',
          correct: 0,
          sequence: 0
        },
        {
          id: 0,
          answer: '',
          correct: 0,
          sequence: 0
        }
      ]
    });

    // Get the index of the first incorrect answers per question
    this.incorrectAnswers = this.questions.map(data => {
      return data.answers.findIndex(x => x.correct == 0);
    });
  }

  deleteSummary(id: number) {
    this.summaries.splice(id, 1);
  }

  deleteQuestion(id: number) {
    this.questions.splice(id, 1);
  }

  deleteAnswer(questionId: number, id: number) {
    this.questions[questionId].answers.splice(id, 1);
  }

  addBlankModule() {
    this.addNewModule = true;
    this.modules = [{
      details: {
        id: 0,
        name: '',
        series_id: 0,
        sequence_number: this.moduleLength + 1,
        description: '',
        cover_url: '',
        video_url: '',
        video_duration: 0,
        cover_color: '#3b6982',
        module_points: 0
      },
      quiz: {
        questions: []
      },
      summary: []
    }];

    this.moduleDetails = this.modules[0];
    this.questions = [];
    this.summaries = [];
    this.coverColor = this.moduleDetails.details?.cover_color;
    this.f.moduleName.setValue('');
    this.f.moduleDescription.setValue('');
    this.imageSourcePreview = '';
    this.imageUploadLabel = 'Upload';
    this.videoSourcePreview = [];
    this.videoUploadLabel = 'Upload';
    this.sequenceNo = this.moduleLength + 1;

    this.loading = false;
  }

  getCoverColor(color: any) {
    this.coverColor = color;
  }

  onImageFileInputChange(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {

      this.imageError = false;

      const [file] = event.target.files;
      this.imageUploadLabel = file.name;

      // Get the image file attributes
      this.imageUploadFile = file;

      // Get the image source preview
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSourcePreview = reader.result as string;
      };
    }
  }

  deleteImageUpload() {
    this.imageSourcePreview = '';
    this.imageFileInput.nativeElement.value = '';
    this.imageUploadLabel = 'Upload';
  }

  deleteVideoUpload() {
    this.videoSourcePreview = [];
    this.videoFileInput.nativeElement.value = '';
    this.videoUploadLabel = 'Upload';
  }

  onVideoFileInputChange(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {

      this.videoError = false;

      const [file] = event.target.files;

      // Check video file size
      if (file.size > 52428800) {
        this.videoErrorMsg = 'The uploaded video file is too large. The maximum video file size is 50 MB.';
        this.videoError = true;

        setTimeout(() => {
          this.videoError = false;
          this.videoErrorMsg = '';
          this.videoFileInput.nativeElement.value = '';
        }, 5000);

        return;
      }

      this.videoUploadLabel = file.name;

      // Get the video file attributes
      this.videoUploadFile = file;

      // Get the video source preview
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.videoSourcePreview.push({
          src: reader.result as string
        });
      };
    }
  }

  changeSeriesStatus(status: any) {
    this.seriesStatusText = (status) ? 'Published' : 'Draft';
    if (this.moduleLength < 3) {
      setTimeout(() => {
        this.isPublished = false;
        this.seriesStatusText = 'Draft';
      }, 0);

      this.changeSeriesStatusError = true;
      return;
    }

    this.isPublished = status;
    this.changeSeriesStatusError = false;
    this.seriesService.updateSeries(this.seriesId, '', 0, this.seriesStatusText.toLowerCase())
      .pipe(first())
      .subscribe(
        seriesData => { },
        error => { }
      );

  }

  // Convenience getter for easy access to form fields
  get f() { return this.moduleForm.controls; }

  onSubmit() {
    this.submitted = true;

    // Stop here if there's form errors
    if (this.moduleForm.invalid) {
        return;
    }

    // Check for image upload
    if (this.imageUploadFile === undefined && this.addNewModule) {
      const moduleContainer: HTMLElement = document.getElementById('module-details-container');
      const imageContainer: HTMLElement = document.getElementById('image-container');

      const scrollTop = (imageContainer?.getBoundingClientRect().top - moduleContainer?.getBoundingClientRect().top);
      this.scrollToTarget(scrollTop, moduleContainer);

      this.imageError = true;
      return;
    }

    // Check for video upload
    if (this.videoUploadFile === undefined && this.addNewModule) {
      const moduleContainer: HTMLElement = document.getElementById('module-details-container');
      const videoContainer: HTMLElement = document.getElementById('video-container');

      const scrollTop = (videoContainer?.getBoundingClientRect().top - moduleContainer?.getBoundingClientRect().top);
      this.scrollToTarget(scrollTop, moduleContainer);

      this.videoError = true;
      return;
    }

    // Check for empty values on questionaires
    if (this.questions.length > 0) {
      let questionError = false;

      // Remove p tags on questions
      this.questions.map(questions => {
        let question = questions.question;
        question = question.replace('<p>', '');
        question = question.replace('</p>', '');
        return questions.question = question;
      });

      // Remove p tags on answers
      this.questions.forEach(question => {
        question.answers.map((value, key) => {
          let answer = value.answer;
          answer = answer.replace('<p>', '');
          answer = answer.replace('</p>', '');
          return value.answer = answer;
        });
      });

      // Get the updated sequence of the summary
      this.questions.forEach(question => {
        question.answers.map((value, key) => {
          return value.sequence = key + 1;
        });
      });

      this.questions.forEach((question, qIndex) => {
        // Check for empty questions
        if (question.question === '') {
          const moduleContainer: HTMLElement = document.getElementById('module-details-container');
          const questionContainer: HTMLElement = document.getElementById('question_' + qIndex + '_' + this.seriesId);
          const scrollTop = (questionContainer?.getBoundingClientRect().top - moduleContainer?.getBoundingClientRect().top);
          this.scrollToTarget(scrollTop, moduleContainer);
          questionError = true;
          return;
        }

        // Check for empty answers
        question.answers.forEach(answer => {
          if (answer.answer === '') {
            const moduleContainer: HTMLElement = document.getElementById('module-details-container');
            const questionContainer: HTMLElement = document.getElementById('question_' + qIndex + '_' + this.seriesId);
            const scrollTop = (questionContainer?.getBoundingClientRect().top - moduleContainer?.getBoundingClientRect().top);
            this.scrollToTarget(scrollTop, moduleContainer);
            questionError = true;
            return;
          }
        });
      });

      if (questionError) {
        return;
      }

    }

    // Check for empty values on summaries
    if (this.summaries.length > 0) {

      // Get the updated sequence of the summary
      this.summaries.map((value, key) => {
        return value.sequence = key + 1;
      });

      let summaryError = false;
      this.summaries.forEach((summary, sIndex) => {
        if (summary.text === '') {
          const moduleContainer: HTMLElement = document.getElementById('module-details-container');
          const summaryContainer: HTMLElement = document.getElementById('summary_' + sIndex + '_' + this.seriesId);
          const scrollTop = (summaryContainer?.getBoundingClientRect().top - moduleContainer?.getBoundingClientRect().top);
          this.scrollToTarget(scrollTop, moduleContainer);
          summaryError = true;
          return;
        }
      });

      if (summaryError) {
        return;
      }
    }

    const moduleData = new FormData();
    const questionData = (this.questions.length > 0) ? this.questions : JSON.parse('[]');
    const summaryData = (this.summaries.length > 0) ? this.summaries : JSON.parse('[]');

    // Image Upload
    if (this.imageUploadFile !== undefined) {
      const imageFInput = this.imageFileInput.nativeElement;
      if (imageFInput.files && imageFInput.files[0]) {
        moduleData.append('cover', imageFInput.files[0]);
      }
    }

    // Video Upload
    if (this.videoUploadFile !== undefined) {
      const videoFInput = this.videoFileInput.nativeElement;
      if (videoFInput.files && videoFInput.files[0]) {
        moduleData.append('video', videoFInput.files[0]);
        const videoDuration = Math.round(this.videoPlayer.duration).toString();
        moduleData.append('video_duration', videoDuration);
      }
    }

    // Add id for existing series
    if (!this.addNewModule && this.moduleId) {
      moduleData.append('id', this.moduleId.toString());
      this.modalMessage = 'Module was successfully updated.';
    }

    moduleData.append('sequence', this.sequenceNo.toString());
    moduleData.append('name', this.f.moduleName.value);
    moduleData.append('description', this.f.moduleDescription.value);
    moduleData.append('color', this.coverColor.substr(1));
    moduleData.append('questions', JSON.stringify(questionData));
    moduleData.append('summary', JSON.stringify(summaryData));

    // Dev purposes only
    // moduleData.forEach((data, key) => {
    //   console.log(key + ':' + data);
    // });

    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Saving...';

    this.seriesService.addSeriesModule(this.seriesId, moduleData)
      .pipe(first())
      .subscribe(
        seriesData => {
          // hide progress modal
          this.hideProgressModal();

          if (seriesData.success) {
            // hide progress modal
            this.hideProgressModal();

            const moduleSequenceNo = seriesData.data.module?.sequence_number;

            // Navigate to first module of the current series
            this.router.navigateByUrl('/admin/series/' + this.seriesId + '/' + moduleSequenceNo, {
              state: {newModuleSuccess: true, modalMessage: this.modalMessage}
            });
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;

          this.submitError = true;
          this.submitSuccess = false;
        }
      );

  }

  private capitalizeFirstCharacter(status: string) {
    return status.charAt(0).toUpperCase() + status.slice(1);
  }

  private sortByValues(a, b) {
    const bandA = a.details.sequence_number;
    const bandB = b.details.sequence_number;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  private scrollToTarget(target: any, containerEl: HTMLElement) {
    if (containerEl != null) {
      const isElement = target && target.nodeType === 1;
      const isNumber = Object.prototype.toString.call(target) === '[object Number]';

      if (isElement) {
        containerEl.scrollTop = target.offsetTop;
      } else if (isNumber) {
        containerEl.scrollTop = target;
      } else if (target === 'bottom') {
        containerEl.scrollTop = containerEl.scrollHeight - containerEl.offsetHeight;
      } else if (target === 'top') {
        containerEl.scrollTop = 0;
      }
    }
  }

  onFocusQuestion(event: any, questionId: number) {
    jquery('#question_tiny_mce_' + questionId).css('border-bottom', '2px solid #3b6982');
  }

  onFocusOutQuestion(event: any, questionId: number) {
    jquery('#question_tiny_mce_' + questionId).css('border-bottom', 'none');
  }

  onFocusAnswer(event: any, questionId: number, answerId: number) {
    jquery('#answer_tiny_mce_' + questionId + '_' + answerId).css('border-bottom', '2px solid #3b6982');
  }

  onFocusOutAnswer(event: any, questionId: number, answerId: number) {
    jquery('#answer_tiny_mce_' + questionId + '_' + answerId).css('border-bottom', 'none');
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
